import { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material'

export function LinkInputDialog ({ open, onClose, onSubmit }) {
  const [url, setUrl] = useState('')

  const handleSubmit = () => {
    if (url) {
      onSubmit(url)
      setUrl('')
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Insert Link</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          label='URL'
          type='url'
          fullWidth
          variant='standard'
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit}>Insert</Button>
      </DialogActions>
    </Dialog>
  )
}
